const FAILED_TO_CREATE = 'FAILED_TO_CREATE'
const FAILED_TO_OPEN = 'FAILED_TO_OPEN'
const ERROR_MESSAGE = 'ERROR_MESSAGE'
const CLOSED_UNEXPECTEDLY = 'CLOSED_UNEXPECTEDLY'
const SUBSCRIBE_TIMED_OUT = 'SUBSCRIBE_TIMED_OUT'

const messages = {
  [FAILED_TO_CREATE]: 'Failed to create websocket connection.',
  [FAILED_TO_OPEN]: 'Failed to have websocket connection opened.',
  [ERROR_MESSAGE]: 'Received an error message',
  [CLOSED_UNEXPECTEDLY]: 'The connection unexpectedly closed.',
  [SUBSCRIBE_TIMED_OUT]: 'Did not subscribe in time.'
}

class WebSocketConnectionError extends Error {
  constructor(reason, originalError = undefined) {
    super()
    this.name = 'WebSocketConnectionError'
    this.message = messages[reason] || 'Sorry, there was a technical issue'
    this.reason = reason
    if (originalError) {
      this.message += `(details: ${originalError.message})`
    }
  }
}

WebSocketConnectionError.Reasons = {
  FAILED_TO_CREATE,
  FAILED_TO_OPEN,
  ERROR_MESSAGE,
  CLOSED_UNEXPECTEDLY,
  SUBSCRIBE_TIMED_OUT
}

export default WebSocketConnectionError
